import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { usePageTracking } from "../Hooks/usePageTracking";
import BubbleListPage from "../Pages/Home/BubbleListPage";
import OpenedBubblePage from "../Pages/OpenedBubble/OpenedBubblePage";
import LinkListPage from "../Pages/LinkList/LinksListPage";
import ContactsListPage from "../Pages/ContactList/ContactsListPage";
import MailCheckPage from "../Pages/MailCheck/MailCheckPage";
import AccessSendMailPage from "../Pages/AccessSendMail/AccessSendMailPage";
import AccessFormPage from "../Pages/AccessForm/AccessFormPage";
import PageHeader from "../Layout/PageHeader/PageHeader";
import DynamicBodyClass from "../Components/DynamicBodyClass/DynamicBodyClass";
import AdminValidationSuccessPage from "../Pages/AdminValidation/AdminValidationSuccessPage";
import AdminValidationRefusedPage from "../Pages/AdminValidation/AdminValidationRefusedPage";
import ValidatedActionPage from "../Pages/AccessForm/ValidatedActionPage";

const PageTracker: React.FC = () => {
  usePageTracking();
  return null;
};

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <PageTracker />
      <PageHeader />
      <DynamicBodyClass />
      <div className="Container">
        <div className="FrontDiv">
          <Routes>
            <Route path="/" element={<BubbleListPage />} />
            <Route path="/Bubble/:Id" element={<OpenedBubblePage />} />
            <Route path="/LinkGroup/:Id" element={<LinkListPage />} />
            <Route path="/ContactGroup/:Id" element={<ContactsListPage />} />
            <Route path="/MailCheck" element={<MailCheckPage />} />
            <Route path="/AccessSendMail" element={<AccessSendMailPage />} />
            <Route path="/AccessForm" element={<AccessFormPage />} />
            <Route path="/AccessFormSended" element={<ValidatedActionPage/>} />
            <Route path="/AdminValidationSuccess" element={<AdminValidationSuccessPage/>} />
            <Route path="/AdminValidationRefused" element={<AdminValidationRefusedPage/>} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default AppRoutes;
